// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"cf5efab4","787":"4117a6de"}[chunkId] + ".chunk.js";
};